
export async function instantiate(imports={}, runInitializer=true) {
    const cachedJsObjects = new WeakMap();
    // ref must be non-null
    function getCachedJsObject(ref, ifNotCached) {
        if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
        const cached = cachedJsObjects.get(ref);
        if (cached !== void 0) return cached;
        cachedJsObjects.set(ref, ifNotCached);
        return ifNotCached;
    }

    const _ref_Li9za2lrby5tanM_ = imports['./skiko.mjs'];
    const _ref_QGpzLWpvZGEvY29yZQ_ = imports['@js-joda/core'];
    
    const js_code = {
        'kotlin.captureStackTrace' : () => new Error().stack,
        'kotlin.wasm.internal.throwJsError' : (message, wasmTypeName, stack) => { 
            const error = new Error();
            error.message = message;
            error.name = wasmTypeName;
            error.stack = stack;
            throw error;
             },
        'kotlin.wasm.internal.stringLength' : (x) => x.length,
        'kotlin.wasm.internal.jsExportStringToWasm' : (src, srcOffset, srcLength, dstAddr) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, dstAddr, srcLength);
            let arrayIndex = 0;
            let srcIndex = srcOffset;
            while (arrayIndex < srcLength) {
                mem16.set([src.charCodeAt(srcIndex)], arrayIndex);
                srcIndex++;
                arrayIndex++;
            }     
             },
        'kotlin.wasm.internal.importStringFromWasm' : (address, length, prefix) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, address, length);
            const str = String.fromCharCode.apply(null, mem16);
            return (prefix == null) ? str : prefix + str;
             },
        'kotlin.wasm.internal.externrefToBoolean' : (ref) => Boolean(ref),
        'kotlin.wasm.internal.getJsEmptyString' : () => '',
        'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
        'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
        'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
        'kotlin.wasm.internal.externrefHashCode' : 
        (() => {
        const dataView = new DataView(new ArrayBuffer(8));
        function numberHashCode(obj) {
            if ((obj | 0) === obj) {
                return obj | 0;
            } else {
                dataView.setFloat64(0, obj, true);
                return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
            }
        }
        
        const hashCodes = new WeakMap();
        function getObjectHashCode(obj) {
            const res = hashCodes.get(obj);
            if (res === undefined) {
                const POW_2_32 = 4294967296;
                const hash = (Math.random() * POW_2_32) | 0;
                hashCodes.set(obj, hash);
                return hash;
            }
            return res;
        }
        
        function getStringHashCode(str) {
            var hash = 0;
            for (var i = 0; i < str.length; i++) {
                var code  = str.charCodeAt(i);
                hash  = (hash * 31 + code) | 0;
            }
            return hash;
        }
        
        return (obj) => {
            if (obj == null) {
                return 0;
            }
            switch (typeof obj) {
                case "object":
                case "function":
                    return getObjectHashCode(obj);
                case "number":
                    return numberHashCode(obj);
                case "boolean":
                    return obj ? 1231 : 1237;
                default:
                    return getStringHashCode(String(obj)); 
            }
        }
        })(),
        'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
        'kotlin.wasm.internal.getJsTrue' : () => true,
        'kotlin.wasm.internal.getJsFalse' : () => false,
        'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
        'kotlin.js.jsCatch' : (f) => { 
            let result = null;
            try { 
                f();
            } catch (e) {
               result = e;
            }
            return result;
             },
        'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
        'kotlin.js.jsThrow' : (e) => { throw e; },
        'kotlin.io.printError' : (error) => console.error(error),
        'kotlin.io.printlnImpl' : (message) => console.log(message),
        'kotlin.js.jsArrayGet' : (array, index) => array[index],
        'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
        'kotlin.js.JsArray_$external_fun' : () => new Array(),
        'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
        'kotlin.js.JsArray_$external_class_instanceof' : (x) => x instanceof Array,
        'kotlin.js.stackPlaceHolder_js_code' : () => (''),
        'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
        'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
        'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
        'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
        'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
        'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
        'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
        'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
        'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
        'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
        'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
        'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
        'kotlin.time.dateNow' : () => Date.now(),
        'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
        'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
        'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
        'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
        'kotlinx.coroutines.console_$external_prop_getter' : () => console,
        'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
        'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
        'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
        'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
            const handler = (event) => {
                if (event.source == window && event.data == 'dispatchCoroutine') {
                    event.stopPropagation();
                    process();
                }
            }
            window.addEventListener('message', handler, true);
        },
        'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
        'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
        'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
        'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
        'kotlinx.browser.window_$external_prop_getter' : () => window,
        'kotlinx.browser.document_$external_prop_getter' : () => document,
        'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
        'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
        'org.khronos.webgl.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
        'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
        'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
        'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
        'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
        'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
        'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
        'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
        'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
        'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
        'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
        'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
        'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
        'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
        'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
        'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
        'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
        'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
        'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
        'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
        'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
        'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
        'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
        'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
        'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
        'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
        'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
        'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
        'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
        'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
        'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => { return { passive, once, capture }; },
        'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.w3c.dom.screen_$external_prop_getter' : (_this) => _this.screen,
        'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
        'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
        'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
        'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
        'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
        'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
        'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
        'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
        'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
        'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
        'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
        'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.dom.head_$external_prop_getter' : (_this) => _this.head,
        'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
        'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.createTextNode_$external_fun' : (_this, p0) => _this.createTextNode(p0),
        'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
        'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
        'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
        'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
        'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
        'org.w3c.dom.getElementsByTagName_$external_fun' : (_this, p0) => _this.getElementsByTagName(p0),
        'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
        'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
        'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
        'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
        'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
        'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
        'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
        'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
        'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
        'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
        'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
        'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
        'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
        'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
        'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
        'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
        'org.w3c.dom.right_$external_prop_getter' : (_this) => _this.right,
        'org.w3c.dom.bottom_$external_prop_getter' : (_this) => _this.bottom,
        'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
        'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
        'org.w3c.dom.HTMLTitleElement_$external_class_instanceof' : (x) => x instanceof HTMLTitleElement,
        'org.w3c.dom.type_$external_prop_setter' : (_this, v) => _this.type = v,
        'org.w3c.dom.HTMLStyleElement_$external_class_instanceof' : (x) => x instanceof HTMLStyleElement,
        'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.w3c.dom.targetTouches_$external_prop_getter' : (_this) => _this.targetTouches,
        'org.w3c.dom.changedTouches_$external_prop_getter' : (_this) => _this.changedTouches,
        'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
        'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
        'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
        'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
        'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
        'org.w3c.files.slice_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.slice(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
        'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
        'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
        'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
        'org.w3c.xhr.open_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.open(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
        'org.w3c.xhr.send_$external_fun' : (_this, ) => _this.send(),
        'org.w3c.xhr.overrideMimeType_$external_fun' : (_this, p0) => _this.overrideMimeType(p0),
        'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.jetbrains.skiko.w3c.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.skiko.w3c.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
        'org.jetbrains.skiko.w3c.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.jetbrains.skiko.w3c.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.jetbrains.skiko.w3c.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.jetbrains.skiko.w3c.open_$external_fun' : (_this, p0, p1) => _this.open(p0, p1),
        'org.jetbrains.skiko.w3c.window_$external_object_getInstance' : () => window,
        'org.jetbrains.skiko.w3c.now_$external_fun' : (_this, ) => _this.now(),
        'org.jetbrains.skiko.w3c.width_$external_prop_getter' : (_this) => _this.width,
        'org.jetbrains.skiko.w3c.height_$external_prop_getter' : (_this) => _this.height,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
        'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
        'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
        'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_._releaseLocalCallbackScope(),
        'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
        'org.jetbrains.skiko.wasm.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
        'org.jetbrains.skiko.wasm.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
        'org.jetbrains.skiko.wasm.GL_$external_object_getInstance' : () => _ref_Li9za2lrby5tanM_.GL,
        'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
            return {
                alpha: 1,
                depth: 1,
                stencil: 8,
                antialias: 0,
                premultipliedAlpha: 1,
                preserveDrawingBuffer: 0,
                preferLowPowerToHighPerformance: 0,
                failIfMajorPerformanceCaveat: 0,
                enableExtensionsByDefault: 1,
                explicitSwapControl: 0,
                renderViaOffscreenBackBuffer: 0,
                majorVersion: 2,
            }
        }
        ,
        'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
        'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
        'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
        'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
        'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
        'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext,
        'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
        'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
        'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
        'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
        'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
        'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
        'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
        'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
        'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
        'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
        'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
        'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
        'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
        'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
        'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
        'androidx.compose.ui.platform.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
        'androidx.compose.ui.window.force_$external_prop_getter' : (_this) => _this.force,
        'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
        'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
        'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
        'kotlinx.datetime.internal.JSJoda.atStartOfDay_$external_fun' : (_this, p0) => _this.atStartOfDay(p0),
        'kotlinx.datetime.internal.JSJoda.compareTo_$external_fun' : (_this, p0) => _this.compareTo(p0),
        'kotlinx.datetime.internal.JSJoda.dayOfMonth_$external_fun' : (_this, ) => _this.dayOfMonth(),
        'kotlinx.datetime.internal.JSJoda.dayOfWeek_$external_fun' : (_this, ) => _this.dayOfWeek(),
        'kotlinx.datetime.internal.JSJoda.equals_$external_fun' : (_this, p0) => _this.equals(p0),
        'kotlinx.datetime.internal.JSJoda.hashCode_$external_fun' : (_this, ) => _this.hashCode(),
        'kotlinx.datetime.internal.JSJoda.monthValue_$external_fun' : (_this, ) => _this.monthValue(),
        'kotlinx.datetime.internal.JSJoda.plusDays_$external_fun' : (_this, p0) => _this.plusDays(p0),
        'kotlinx.datetime.internal.JSJoda.plusMonths_$external_fun' : (_this, p0) => _this.plusMonths(p0),
        'kotlinx.datetime.internal.JSJoda.toEpochDay_$external_fun' : (_this, ) => _this.toEpochDay(),
        'kotlinx.datetime.internal.JSJoda.toString_$external_fun' : (_this, ) => _this.toString(),
        'kotlinx.datetime.internal.JSJoda.year_$external_fun' : (_this, ) => _this.year(),
        'kotlinx.datetime.internal.JSJoda.MIN_$external_prop_getter' : (_this) => _this.MIN,
        'kotlinx.datetime.internal.JSJoda.MAX_$external_prop_getter' : (_this) => _this.MAX,
        'kotlinx.datetime.internal.JSJoda.of_$external_fun' : (_this, p0, p1, p2) => _this.of(p0, p1, p2),
        'kotlinx.datetime.internal.JSJoda.parse_$external_fun' : (_this, p0) => _this.parse(p0),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.LocalDate,
        'kotlinx.datetime.internal.JSJoda.LocalDate_$external_class_instanceof' : (x) => x instanceof _ref_QGpzLWpvZGEvY29yZQ_.LocalDate,
        'kotlinx.datetime.internal.JSJoda.value_$external_fun' : (_this, ) => _this.value(),
        'kotlinx.datetime.internal.JSJoda.value_$external_fun_1' : (_this, ) => _this.value(),
        'kotlinx.datetime.internal.JSJoda.atZone_$external_fun' : (_this, p0) => _this.atZone(p0),
        'kotlinx.datetime.internal.JSJoda.compareTo_$external_fun_1' : (_this, p0) => _this.compareTo(p0),
        'kotlinx.datetime.internal.JSJoda.dayOfMonth_$external_fun_1' : (_this, ) => _this.dayOfMonth(),
        'kotlinx.datetime.internal.JSJoda.equals_$external_fun_1' : (_this, p0) => _this.equals(p0),
        'kotlinx.datetime.internal.JSJoda.hashCode_$external_fun_1' : (_this, ) => _this.hashCode(),
        'kotlinx.datetime.internal.JSJoda.month_$external_fun' : (_this, ) => _this.month(),
        'kotlinx.datetime.internal.JSJoda.monthValue_$external_fun_1' : (_this, ) => _this.monthValue(),
        'kotlinx.datetime.internal.JSJoda.toLocalDate_$external_fun' : (_this, ) => _this.toLocalDate(),
        'kotlinx.datetime.internal.JSJoda.toLocalTime_$external_fun' : (_this, ) => _this.toLocalTime(),
        'kotlinx.datetime.internal.JSJoda.toString_$external_fun_1' : (_this, ) => _this.toString(),
        'kotlinx.datetime.internal.JSJoda.year_$external_fun_1' : (_this, ) => _this.year(),
        'kotlinx.datetime.internal.JSJoda.MIN_$external_prop_getter_1' : (_this) => _this.MIN,
        'kotlinx.datetime.internal.JSJoda.MAX_$external_prop_getter_1' : (_this) => _this.MAX,
        'kotlinx.datetime.internal.JSJoda.of_$external_fun_1' : (_this, p0, p1) => _this.of(p0, p1),
        'kotlinx.datetime.internal.JSJoda.ofInstant_$external_fun' : (_this, p0, p1) => _this.ofInstant(p0, p1),
        'kotlinx.datetime.internal.JSJoda.parse_$external_fun_1' : (_this, p0) => _this.parse(p0),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance_1' : () => _ref_QGpzLWpvZGEvY29yZQ_.LocalDateTime,
        'kotlinx.datetime.internal.JSJoda.LocalDateTime_$external_class_instanceof' : (x) => x instanceof _ref_QGpzLWpvZGEvY29yZQ_.LocalDateTime,
        'kotlinx.datetime.internal.JSJoda.compareTo_$external_fun_2' : (_this, p0) => _this.compareTo(p0),
        'kotlinx.datetime.internal.JSJoda.equals_$external_fun_2' : (_this, p0) => _this.equals(p0),
        'kotlinx.datetime.internal.JSJoda.hashCode_$external_fun_2' : (_this, ) => _this.hashCode(),
        'kotlinx.datetime.internal.JSJoda.hour_$external_fun' : (_this, ) => _this.hour(),
        'kotlinx.datetime.internal.JSJoda.minute_$external_fun' : (_this, ) => _this.minute(),
        'kotlinx.datetime.internal.JSJoda.nano_$external_fun' : (_this, ) => _this.nano(),
        'kotlinx.datetime.internal.JSJoda.second_$external_fun' : (_this, ) => _this.second(),
        'kotlinx.datetime.internal.JSJoda.toSecondOfDay_$external_fun' : (_this, ) => _this.toSecondOfDay(),
        'kotlinx.datetime.internal.JSJoda.toString_$external_fun_2' : (_this, ) => _this.toString(),
        'kotlinx.datetime.internal.JSJoda.MIN_$external_prop_getter_2' : (_this) => _this.MIN,
        'kotlinx.datetime.internal.JSJoda.MAX_$external_prop_getter_2' : (_this) => _this.MAX,
        'kotlinx.datetime.internal.JSJoda.of_$external_fun_2' : (_this, p0, p1, p2, p3) => _this.of(p0, p1, p2, p3),
        'kotlinx.datetime.internal.JSJoda.parse_$external_fun_2' : (_this, p0) => _this.parse(p0),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance_2' : () => _ref_QGpzLWpvZGEvY29yZQ_.LocalTime,
        'kotlinx.datetime.internal.JSJoda.LocalTime_$external_class_instanceof' : (x) => x instanceof _ref_QGpzLWpvZGEvY29yZQ_.LocalTime,
        'kotlinx.datetime.internal.JSJoda.parse_$external_fun_3' : (_this, p0) => _this.parse(p0),
        'kotlinx.datetime.internal.JSJoda.DateTimeFormatterBuilder_$external_fun' : () => new _ref_QGpzLWpvZGEvY29yZQ_.DateTimeFormatterBuilder(),
        'kotlinx.datetime.internal.JSJoda.appendOffset_$external_fun' : (_this, p0, p1) => _this.appendOffset(p0, p1),
        'kotlinx.datetime.internal.JSJoda.appendOffsetId_$external_fun' : (_this, ) => _this.appendOffsetId(),
        'kotlinx.datetime.internal.JSJoda.parseCaseInsensitive_$external_fun' : (_this, ) => _this.parseCaseInsensitive(),
        'kotlinx.datetime.internal.JSJoda.toFormatter_$external_fun' : (_this, p0) => _this.toFormatter(p0),
        'kotlinx.datetime.internal.JSJoda.STRICT_$external_prop_getter' : (_this) => _this.STRICT,
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance_3' : () => _ref_QGpzLWpvZGEvY29yZQ_.ResolverStyle,
        'kotlinx.datetime.internal.JSJoda.equals_$external_fun_3' : (_this, p0) => _this.equals(p0),
        'kotlinx.datetime.internal.JSJoda.hashCode_$external_fun_3' : (_this, ) => _this.hashCode(),
        'kotlinx.datetime.internal.JSJoda.toString_$external_fun_3' : (_this, ) => _this.toString(),
        'kotlinx.datetime.internal.JSJoda.totalSeconds_$external_fun' : (_this, ) => _this.totalSeconds(),
        'kotlinx.datetime.internal.JSJoda.UTC_$external_prop_getter' : (_this) => _this.UTC,
        'kotlinx.datetime.internal.JSJoda.ofHoursMinutesSeconds_$external_fun' : (_this, p0, p1, p2) => _this.ofHoursMinutesSeconds(p0, p1, p2),
        'kotlinx.datetime.internal.JSJoda.ofTotalSeconds_$external_fun' : (_this, p0) => _this.ofTotalSeconds(p0),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance_4' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneOffset,
        'kotlinx.datetime.internal.JSJoda.ZoneOffset_$external_class_instanceof' : (x) => x instanceof _ref_QGpzLWpvZGEvY29yZQ_.ZoneOffset,
        'kotlinx.datetime.internal.JSJoda.get_$external_fun' : (_this, p0) => _this.get(p0),
        'kotlinx.datetime.internal.JSJoda.OFFSET_SECONDS_$external_prop_getter' : (_this) => _this.OFFSET_SECONDS,
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance_5' : () => _ref_QGpzLWpvZGEvY29yZQ_.ChronoField,
        'kotlinx.datetime.internal.JSJoda.equals_$external_fun_4' : (_this, p0) => _this.equals(p0),
        'kotlinx.datetime.internal.JSJoda.hashCode_$external_fun_4' : (_this, ) => _this.hashCode(),
        'kotlinx.datetime.internal.JSJoda.normalized_$external_fun' : (_this, ) => _this.normalized(),
        'kotlinx.datetime.internal.JSJoda.rules_$external_fun' : (_this, ) => _this.rules(),
        'kotlinx.datetime.internal.JSJoda.toString_$external_fun_4' : (_this, ) => _this.toString(),
        'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
        'kotlinx.datetime.internal.JSJoda.of_$external_fun_3' : (_this, p0) => _this.of(p0),
        'kotlinx.datetime.internal.JSJoda.getAvailableZoneIds_$external_fun' : (_this, ) => _this.getAvailableZoneIds(),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance_6' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
        'kotlinx.datetime.internal.JSJoda.ZoneId_$external_class_instanceof' : (x) => x instanceof _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
        'kotlinx.datetime.internal.JSJoda.instant_$external_fun' : (_this, ) => _this.instant(),
        'kotlinx.datetime.internal.JSJoda.systemUTC_$external_fun' : (_this, ) => _this.systemUTC(),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance_7' : () => _ref_QGpzLWpvZGEvY29yZQ_.Clock,
        'kotlinx.datetime.internal.JSJoda.compareTo_$external_fun_3' : (_this, p0) => _this.compareTo(p0),
        'kotlinx.datetime.internal.JSJoda.epochSecond_$external_fun' : (_this, ) => _this.epochSecond(),
        'kotlinx.datetime.internal.JSJoda.equals_$external_fun_5' : (_this, p0) => _this.equals(p0),
        'kotlinx.datetime.internal.JSJoda.hashCode_$external_fun_5' : (_this, ) => _this.hashCode(),
        'kotlinx.datetime.internal.JSJoda.nano_$external_fun_1' : (_this, ) => _this.nano(),
        'kotlinx.datetime.internal.JSJoda.toString_$external_fun_5' : (_this, ) => _this.toString(),
        'kotlinx.datetime.internal.JSJoda.MIN_$external_prop_getter_3' : (_this) => _this.MIN,
        'kotlinx.datetime.internal.JSJoda.MAX_$external_prop_getter_3' : (_this) => _this.MAX,
        'kotlinx.datetime.internal.JSJoda.ofEpochSecond_$external_fun' : (_this, p0, p1) => _this.ofEpochSecond(p0, p1),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance_8' : () => _ref_QGpzLWpvZGEvY29yZQ_.Instant,
        'kotlinx.datetime.internal.JSJoda.Instant_$external_class_instanceof' : (x) => x instanceof _ref_QGpzLWpvZGEvY29yZQ_.Instant,
        'kotlinx.datetime.internal.JSJoda.isFixedOffset_$external_fun' : (_this, ) => _this.isFixedOffset(),
        'kotlinx.datetime.internal.JSJoda.toInstant_$external_fun' : (_this, ) => _this.toInstant(),
        'kotlinx.datetime.withCaughtJsException' : (body) => {
            try {
                body();
                return null;
            } catch(e) {
                return e;
            }
        },
        'kotlinx.datetime.getExceptionMessage' : (jsException) => jsException.message,
        'kotlinx.datetime.checkExceptionName' : (exception, name) => exception.name === name,
        'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'androidx.compose.material3.internal.getFirstDayOfWeek' : (locale) => { try { 
                   return new Intl.Locale(locale).weekInfo.firstDay; 
                } catch (error) { 
                   return -1; 
              }},
        'androidx.compose.material3.internal.getIs24HourFormat' : (localeTag) => {
                    var locale = new Intl.Locale(localeTag);
                    // Check for the hourCycles property first
                    if (locale.hourCycles) {
                        return locale.hourCycles.includes('h23') || locale.hourCycles.includes('h24') ? 1 : 0;
                    }
        
                    // Fallback to hourCycle property
                    if (locale.hourCycle) {
                        return locale.hourCycle === 'h23' || locale.hourCycle === 'h24' ? 1 : 0;
                    }
                    return -1;
                },
        'androidx.compose.material3.internal.emptyLocaleOptions' : () => new Object(),
        'androidx.compose.material3.internal.Date_$external_fun' : (p0) => new Date(p0),
        'androidx.compose.material3.internal.Date_$external_fun_1' : (p0, p1, p2) => new Date(p0, p1, p2),
        'androidx.compose.material3.internal.getDay_$external_fun' : (_this, ) => _this.getDay(),
        'androidx.compose.material3.internal.toLocaleDateString_$external_fun' : (_this, p0, p1, isDefault0) => _this.toLocaleDateString(p0, isDefault0 ? undefined : p1, ),
        'androidx.compose.material3.internal.now_$external_fun' : (_this, ) => _this.now(),
        'androidx.compose.material3.internal.Companion_$external_object_getInstance' : () => Date,
        'androidx.compose.material3.internal.weekday_$external_prop_setter' : (_this, v) => _this.weekday = v,
        'androidx.compose.material3.internal.year_$external_prop_setter' : (_this, v) => _this.year = v,
        'androidx.compose.material3.internal.month_$external_prop_setter' : (_this, v) => _this.month = v,
        'androidx.compose.material3.internal.day_$external_prop_setter' : (_this, v) => _this.day = v,
        'androidx.compose.material3.internal.hour_$external_prop_setter' : (_this, v) => _this.hour = v,
        'androidx.compose.material3.internal.minute_$external_prop_setter' : (_this, v) => _this.minute = v,
        'androidx.compose.material3.internal.second_$external_prop_setter' : (_this, v) => _this.second = v,
        'com.example.kmpeditor.auth.jsGetItem' : (k) => localStorage.getItem(k),
        'com.example.kmpeditor.auth.jsRemoveItem' : (k) => localStorage.removeItem(k),
        'com.example.kmpeditor.auth.jsSetItem' : (k, v) => localStorage.setItem(k, v),
        'com.example.kmpeditor.auth.jsAuthStorageScope' : () => {
            if (typeof window === 'undefined') return '';
            if (typeof window.__MC_TENANT_DOMAIN === 'string' && window.__MC_TENANT_DOMAIN.length > 0) {
                return window.__MC_TENANT_DOMAIN;
            }
            return (window.location && window.location.hostname) ? window.location.hostname : '';
        },
        'com.example.kmpeditor.auth.jsGetHref' : () => window.location.href,
        'com.example.kmpeditor.auth.jsGetParam' : (name) => { var p = new URLSearchParams(window.location.search); return p.get(name); },
        'com.example.kmpeditor.auth.jsRedirect' : (url) => { window.location.href = url; },
        'com.example.kmpeditor.auth.jsCleanUrl' : () => history.replaceState(null, '', window.location.pathname),
        'com.example.kmpeditor.auth.jsXhrPostForm' : (url, body) => {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', url, false);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.send(body);
            if (xhr.status >= 400) throw new Error('HTTP ' + xhr.status + ': ' + xhr.responseText);
            return xhr.responseText;
        },
        'com.example.kmpeditor.auth.jsXhrPostWithToken' : (url, token) => {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', url, false);
            xhr.setRequestHeader('Keycloak-Token', token);
            xhr.withCredentials = true;
            xhr.send(null);
            if (xhr.status >= 400) throw new Error('HTTP ' + xhr.status + ': ' + xhr.responseText);
            return xhr.responseText;
        },
        'com.example.kmpeditor.auth.jsRandomBytes' : (n) => { var b = new Uint8Array(n); crypto.getRandomValues(b); return Array.from(b).join(','); },
        'fw.general.core.getLocalTimezoneOffsetMillis' : () => new Date().getTimezoneOffset() * -60000,
        'com.example.kmpeditor.fw.general.core.jsDateNow' : () => Date.now(),
        'com.example.kmpeditor.fw.general.core.jsIsoFromMs' : (ms) => new Date(ms).toISOString(),
        'com.example.kmpeditor.fw.general.core.jsIsoToday' : () => {
                const d = new Date();
                const pad = (n) => String(n).padStart(2, '0');
                return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
            },
        'com.example.kmpeditor.fw.general.core.jsParseIso' : (s) => { const n = Date.parse(s); return isNaN(n) ? 0 : n; },
        'fw.general.core.ui.jsSetItem' : (key, value) => localStorage.setItem(key, value),
        'fw.general.core.ui.jsGetItem' : (key) => localStorage.getItem(key),
        'fw.general.core.ui.jsSetItem_1' : (key, value) => localStorage.setItem(key, value),
        'fw.general.core.ui.jsGetItem_1' : (key) => localStorage.getItem(key),
        'fw.general.core.ui.jsGetAudioPosition' : () => {
            if (window.__mcAudio) { return window.__mcAudio.currentTime || 0; }
            return 0;
        },
        'fw.general.core.ui.jsGetAudioDuration' : () => {
            if (window.__mcAudio && window.__mcAudio.duration) { return window.__mcAudio.duration; }
            return 0;
        },
        'fw.general.core.ui.jsStopAudio' : () => {
            if (window.__mcAudio) {
                window.__mcAudio.pause();
                window.__mcAudio.currentTime = 0;
            }
        },
        'fw.general.core.ui.jsPauseAudio' : () => {
            if (window.__mcAudio) { window.__mcAudio.pause(); }
        },
        'fw.general.core.ui.jsResumeAudio' : () => {
            if (window.__mcAudio && window.__mcAudio.paused) {
                window.__mcAudio.play().catch(function(e) {});
            }
        },
        'fw.general.core.ui.jsPlayAudio' : (url) => {
            if (window.__mcAudio) { window.__mcAudio.pause(); }
            window.__mcAudio = new Audio(url);
            window.__mcAudio.play().catch(function(e) { console.warn('Audio play failed:', e); });
        },
        'fw.general.core.ui.jsSeekAudio' : (pos) => {
            if (window.__mcAudio) { window.__mcAudio.currentTime = pos; }
        },
        'fw.general.core.ui.jsSetItem_2' : (key, value) => localStorage.setItem(key, value),
        'fw.general.core.ui.jsGetItem_2' : (key) => localStorage.getItem(key),
        'fw.general.core.ui.jsSetupDropZone' : (elementId, callback) => {
            var target = document.getElementById(elementId) || document.body;
            var id = Math.random().toString(36).substr(2, 9);
        
            var dragHandler = function(e) {
                e.preventDefault();
                e.stopPropagation();
                target.style.outline = '3px dashed #1A73E8';
                target.style.outlineOffset = '-3px';
            };
        
            var dragLeaveHandler = function(e) {
                e.preventDefault();
                target.style.outline = '';
                target.style.outlineOffset = '';
            };
        
            var dropHandler = function(e) {
                e.preventDefault();
                e.stopPropagation();
                target.style.outline = '';
                target.style.outlineOffset = '';
        
                var files = e.dataTransfer ? e.dataTransfer.files : null;
                if (!files || files.length === 0) return;
        
                var file = files[0];
                var reader = new FileReader();
                reader.onload = function() {
                    var arr = new Uint8Array(reader.result);
                    callback(file.name, file.type || 'application/octet-stream', arr);
                };
                reader.readAsArrayBuffer(file);
            };
        
            target.addEventListener('dragover', dragHandler);
            target.addEventListener('dragenter', dragHandler);
            target.addEventListener('dragleave', dragLeaveHandler);
            target.addEventListener('drop', dropHandler);
        
            window['__dropzone_' + id] = {
                target: target,
                dragover: dragHandler,
                dragenter: dragHandler,
                dragleave: dragLeaveHandler,
                drop: dropHandler
            };
        
            return id;
        },
        'fw.general.core.ui.__convertKotlinClosureToJsClosure_((String,String,Js)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2) => wasmExports['__callFunction_((String,String,Js)->Unit)'](f, p0, p1, p2)),
        'fw.general.core.ui.jsCleanupDropZone' : (id) => {
            var dz = window['__dropzone_' + id];
            if (!dz) return;
            dz.target.removeEventListener('dragover', dz.dragover);
            dz.target.removeEventListener('dragenter', dz.dragenter);
            dz.target.removeEventListener('dragleave', dz.dragleave);
            dz.target.removeEventListener('drop', dz.drop);
            dz.target.style.outline = '';
            dz.target.style.outlineOffset = '';
            delete window['__dropzone_' + id];
        },
        'fw.general.core.ui.jsLen' : (arr) => arr.length,
        'fw.general.core.ui.jsGet' : (arr, i) => arr[i],
        'fw.general.core.ui.jsRasterizeSvgToPngAsync' : (url) => new Promise(async function(resolve, reject) {
                try {
                    const response = await fetch(url);
                    if (!response.ok) {
                        reject(new Error('HTTP ' + response.status));
                        return;
                    }
                    const svgText = await response.text();
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(svgText, 'image/svg+xml');
                    const root = doc.documentElement;
                    if (!root || String(root.nodeName).toLowerCase() !== 'svg') {
                        reject(new Error('Not an SVG document'));
                        return;
                    }
        
                    function numberAttr(name) {
                        const raw = root.getAttribute(name) || '';
                        const match = raw.match(/[-+]?\d*\.?\d+/);
                        return match ? Number(match[0]) : 0;
                    }
        
                    let width = numberAttr('width');
                    let height = numberAttr('height');
                    const viewBox = (root.getAttribute('viewBox') || '').trim().split(/\s+/).map(Number);
                    if ((!width || !height) && viewBox.length === 4 && Number.isFinite(viewBox[2]) && Number.isFinite(viewBox[3])) {
                        width = width || viewBox[2];
                        height = height || viewBox[3];
                    }
                    if (!width || !height) {
                        width = 840;
                        height = 480;
                    }
        
                    const maxSide = 1200;
                    const scale = Math.min(2, maxSide / Math.max(width, height));
                    const canvas = document.createElement('canvas');
                    canvas.width = Math.max(1, Math.round(width * scale));
                    canvas.height = Math.max(1, Math.round(height * scale));
                    const ctx = canvas.getContext('2d');
                    if (!ctx) {
                        reject(new Error('Canvas 2D is unavailable'));
                        return;
                    }
        
                    const svgBlob = new Blob([svgText], { type: 'image/svg+xml;charset=utf-8' });
                    const objectUrl = URL.createObjectURL(svgBlob);
                    const img = new Image();
                    img.onload = function() {
                        try {
                            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                            URL.revokeObjectURL(objectUrl);
                            canvas.toBlob(async function(blob) {
                                if (!blob) {
                                    reject(new Error('SVG rasterization failed'));
                                    return;
                                }
                                const buffer = await blob.arrayBuffer();
                                resolve(new Uint8Array(buffer));
                            }, 'image/png');
                        } catch (err) {
                            URL.revokeObjectURL(objectUrl);
                            reject(err);
                        }
                    };
                    img.onerror = function() {
                        URL.revokeObjectURL(objectUrl);
                        reject(new Error('SVG image decode failed'));
                    };
                    img.src = objectUrl;
                } catch (err) {
                    reject(err);
                }
            }),
        'fw.general.core.ui.jsArrayLength' : (arr) => arr.length,
        'fw.general.core.ui.jsArrayGet' : (arr, i) => arr[i],
        'fw.general.core.ui.jsOpenUrl' : (url) => window.open(url, '_blank'),
        'fw.general.core.ui.jsQueryParam' : (name) => { var p = new URLSearchParams(window.location.search); var v = p.get(name); return typeof v === 'string' ? v.trim() : ''; },
        'fw.general.core.ui.jsBackendOverride' : () => (typeof window.__BACKEND_URL === 'string' ? window.__BACKEND_URL : ''),
        'fw.general.core.ui.jsLocationOrigin' : () => window.location.origin,
        'fw.general.core.ui.jsDownloadUrl' : 
            (url, fileName) => {
                const a = document.createElement('a');
                a.href = url;
                if (fileName) a.download = fileName;
                a.rel = 'noopener';
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                setTimeout(() => a.remove(), 0);
            }
        ,
        'fw.general.core.ui.jsRendererOverride' : () => (typeof window.__RENDERER_URL === 'string' ? window.__RENDERER_URL : ''),
        'fw.general.core.ui.jsLocationHost' : () => window.location.host,
        'fw.general.core.ui.debug.jsSetItem' : (key, value) => localStorage.setItem(key, value),
        'fw.general.core.ui.debug.jsGetItem' : (key) => localStorage.getItem(key),
        'fw.general.oauth.pollUntilClosed' : (popup, cb) => {
            var h = setInterval(function() {
                if (popup.closed) {
                    clearInterval(h);
                    cb();
                }
            }, 500);
        },
        'fw.general.platform.installComposeCancellationFilter' : () => {
                window.__kmpComposeNoiseFilter = Object.assign(
                    window.__kmpComposeNoiseFilter || {},
                    { kotlinInstalledAt: Date.now(), kotlinSuppressed: 0 }
                );
                // Match anything in the reason chain that signals Kotlin
                // coroutine cancellation cleanup. Two distinct families surface:
                //   1. `…CancellationException` — the actual throwable (plain
                //      CancellationException + Compose's Modifier-detach and
                //      LeftComposition variants + structured-concurrency
                //      JobCancellationException).
                //   2. `…COROUTINE…` — Kotlin's generated suspending-function
                //      state-machine classes (e.g.
                //      `kotlinx.coroutines.flow.$awaitValueCOROUTINE$36`).
                //      Each continuation in a cancelled chain can resume with
                //      `Result.failure(...)` and produce its own Promise
                //      rejection. User code never produces a class with the
                //      `COROUTINE` suffix — it's compiler-only.
                // Cancellation-shape match. Two distinct families:
                //   1. `…CancellationException` — the actual throwable.
                //   2. `…COROUTINE…` / `…$slambda` — Kotlin's generated
                //      suspending-function state-machine classes (continuation
                //      frames that resume with `Result.failure(...)` during
                //      cancelled flow collections). User code never produces
                //      classes with these suffixes — compiler-only.
                const cancellationPattern = /CancellationException|JobCancellationException|LeftCompositionCancellationException|ModifierNodeDetachedCancellationException|COROUTINE|\$slambda/;
                function classNameOf(value) {
                    try { return (value && value.constructor && value.constructor.name) || ''; }
                    catch (e) { return ''; }
                }
                function stringOf(value) {
                    try { return String(value); } catch (e) { return ''; }
                }
                function silence(event) {
                    window.__kmpComposeNoiseFilter.kotlinSuppressed =
                        (window.__kmpComposeNoiseFilter.kotlinSuppressed || 0) + 1;
                    event.preventDefault();
                    if (typeof event.stopImmediatePropagation === 'function') {
                        event.stopImmediatePropagation();
                    }
                }
                function shouldSilence(value) {
                    // Null reason → real error with no metadata; let it through.
                    if (value == null) return false;
                    // Match ONLY the immediate value's class name + its toString
                    // form. We deliberately avoid the stack trace, jsStack, and
                    // nested `cause` walking — real exceptions in this codebase
                    // pass through `androidx.compose.*` and `kotlinx.coroutines.*`
                    // frames, and matching against those would swallow genuine
                    // NPE / IAE / network errors as "framework cancellation".
                    const name = classNameOf(value);
                    if (name && cancellationPattern.test(name)) return true;
                    const str = stringOf(value);
                    if (str && cancellationPattern.test(str)) return true;
                    return false;
                }
                window.addEventListener('unhandledrejection', function(event) {
                    if (shouldSilence(event && event.reason)) silence(event);
                }, true);
                // Window-level `error` events catch wasm exceptions that escape
                // through non-Promise paths — e.g. coroutine continuations
                // resumed from a `requestAnimationFrame` callback (Skiko's
                // render loop, snapshotFlow collectors inside LaunchedEffect).
                // Those land as `error` events, not `unhandledrejection`s, so a
                // rejection-only listener misses them entirely.
                window.addEventListener('error', function(event) {
                    // ErrorEvent carries the original throwable on `.error`,
                    // plus the formatted `.message`. Both feed into `reasonText`.
                    const reason = (event && (event.error || event.message)) || null;
                    if (shouldSilence(reason)) silence(event);
                }, true);
            },
        'fw.general.platform.jsLocalStorageGet' : (key) => localStorage.getItem(key) || '',
        'fw.general.platform.jsRandomUUID' : () => {
            const cryptoApi =
                (typeof globalThis !== 'undefined' && globalThis.crypto)
                    ? globalThis.crypto
                    : null;
        
            if (cryptoApi && typeof cryptoApi.randomUUID === 'function') {
                return cryptoApi.randomUUID();
            }
        
            const bytes = new Uint8Array(16);
            if (cryptoApi && typeof cryptoApi.getRandomValues === 'function') {
                cryptoApi.getRandomValues(bytes);
            } else {
                for (let i = 0; i < bytes.length; i += 1) {
                    bytes[i] = Math.floor(Math.random() * 256);
                }
            }
        
            bytes[6] = (bytes[6] & 0x0f) | 0x40;
            bytes[8] = (bytes[8] & 0x3f) | 0x80;
        
            const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0'));
            return (
                hex.slice(0, 4).join('') + '-' +
                hex.slice(4, 6).join('') + '-' +
                hex.slice(6, 8).join('') + '-' +
                hex.slice(8, 10).join('') + '-' +
                hex.slice(10, 16).join('')
            );
        },
        'fw.general.platform.jsLocalStorageSet' : (key, value) => localStorage.setItem(key, value),
        'fw.general.platform.jsBrowserInfo' : () => {
            const ua = navigator.userAgent || '';
            if (ua.indexOf('Firefox/') !== -1) {
                const m = ua.match(/Firefox\/(\d+(\.\d+)?)/);
                return m ? 'Firefox ' + m[1] : 'Firefox';
            }
            if (ua.indexOf('Edg/') !== -1) {
                const m = ua.match(/Edg\/(\d+(\.\d+)?)/);
                return m ? 'Edge ' + m[1] : 'Edge';
            }
            if (ua.indexOf('OPR/') !== -1 || ua.indexOf('Opera') !== -1) {
                const m = ua.match(/OPR\/(\d+(\.\d+)?)/);
                return m ? 'Opera ' + m[1] : 'Opera';
            }
            if (ua.indexOf('Chrome/') !== -1) {
                const m = ua.match(/Chrome\/(\d+(\.\d+)?)/);
                return m ? 'Chrome ' + m[1] : 'Chrome';
            }
            if (ua.indexOf('Safari/') !== -1) {
                const m = ua.match(/Version\/(\d+(\.\d+)?)/);
                return m ? 'Safari ' + m[1] : 'Safari';
            }
            return ua.substring(0, 40);
        },
        'fw.general.responsiveEditor.jsPickFile' : (accept) => new Promise(function(resolve, reject) {
                var input = document.createElement('input');
                input.type = 'file';
                if (accept && accept.length > 0) input.accept = accept;
                input.style.display = 'none';
                document.body.appendChild(input);
        
                var cleanup = function() { document.body.removeChild(input); };
        
                input.addEventListener('change', function() {
                    var file = input.files[0];
                    if (!file) { cleanup(); reject(new Error('no file')); return; }
                    var reader = new FileReader();
                    reader.onload = function() {
                        var bytes = new Int8Array(reader.result);
                        cleanup();
                        resolve([file.name, file.type || 'application/octet-stream', bytes]);
                    };
                    reader.onerror = function() { cleanup(); reject(reader.error); };
                    reader.readAsArrayBuffer(file);
                });
        
                // Cancel heuristic: when focus returns to the window without a file
                // selection, clean up. Delay because focus fires before change on
                // some browsers.
                var focusHandler = function() {
                    setTimeout(function() {
                        if (input.files.length === 0) {
                            cleanup();
                            reject(new Error('cancelled'));
                        }
                        window.removeEventListener('focus', focusHandler);
                    }, 300);
                };
                window.addEventListener('focus', focusHandler);
        
                input.click();
            }),
        'fw.general.responsiveEditor.jsArrayGet' : (arr, i) => arr[i],
        'fw.general.responsiveEditor.jsInt8ArrayLength' : (arr) => arr.length,
        'fw.general.responsiveEditor.jsInt8ArrayGet' : (arr, i) => arr[i],
        'fw.general.responsiveEditor.ui.jsIsEyeDropperSupported' : () => (typeof window !== 'undefined' && 'EyeDropper' in window),
        'fw.general.responsiveEditor.ui.jsOpenEyeDropper' : () => new Promise(function(resolve) {
                try {
                    if (typeof window === 'undefined' || !('EyeDropper' in window)) {
                        resolve('');
                        return;
                    }
                    var d = new EyeDropper();
                    d.open().then(
                        function(r) { resolve(r && r.sRGBHex ? r.sRGBHex : ''); },
                        function()  { resolve(''); }
                    );
                } catch (e) { resolve(''); }
            }),
        'fw.general.rest.jsXhrGetBinaryAsync' : (url) => new Promise(function(resolve, reject) {
                var xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);
                xhr.responseType = 'arraybuffer';
                xhr.onload = function() {
                    if (xhr.status >= 400) {
                        reject(new Error('HTTP ' + xhr.status));
                    } else {
                        resolve(new Uint8Array(xhr.response));
                    }
                };
                xhr.onerror = function() { reject(new Error('Network error')); };
                xhr.send(null);
            }),
        'fw.general.rest.jsArrayLength' : (arr) => arr.length,
        'fw.general.rest.jsArrayGet' : (arr, i) => arr[i],
        'fw.general.rest.jsCloseEventSource' : (es) => { es.close(); },
        'fw.general.rest.jsOpenEventSource' : (url, onMessage, onError, onOpen) => {
            var tenantDomain = '';
            if (typeof window !== 'undefined') {
                if (typeof window.__MC_TENANT_DOMAIN === 'string' && window.__MC_TENANT_DOMAIN.length > 0) {
                    tenantDomain = window.__MC_TENANT_DOMAIN;
                } else if (window.location && window.location.hostname) {
                    tenantDomain = window.location.hostname;
                }
            }
            if (tenantDomain) {
                var sep = url.indexOf('?') >= 0 ? '&' : '?';
                url = url + sep + 'tenantDomain=' + encodeURIComponent(tenantDomain);
            }
            var es = new EventSource(url);
            es.onopen = function() { onOpen(); };
            es.onmessage = function(e) { onMessage(e.data); };
            es.onerror = function() { onError(); };
            return es;
        },
        'fw.general.rest.__convertKotlinClosureToJsClosure_((String)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String)->Unit)'](f, p0)),
        'fw.general.rest.jsXhrGetAsync' : (url, authHeader, tenantDomain) => new Promise(function(resolve, reject) {
                var xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);
                if (authHeader && authHeader.length > 0) {
                    xhr.setRequestHeader('Authorization', authHeader);
                }
                if (tenantDomain && tenantDomain.length > 0) {
                    xhr.setRequestHeader('X-MC-Tenant-Domain', tenantDomain);
                }
                xhr.onload = function() {
                    if (xhr.status >= 400) {
                        reject(new Error('HTTP ' + xhr.status + ': ' + xhr.responseText));
                    } else {
                        resolve(xhr.responseText);
                    }
                };
                xhr.onerror = function() { reject(new Error('Network error')); };
                xhr.send(null);
            }),
        'fw.general.rest.jsXhrPostWithHeaders' : (url, body, headersJson) => new Promise(resolve => {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', url, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            const headers = JSON.parse(headersJson);
            Object.keys(headers).forEach(key => xhr.setRequestHeader(key, headers[key]));
            xhr.onload = () => resolve(xhr.status + String.fromCharCode(31) + (xhr.responseText || ''));
            xhr.onerror = () => resolve('0' + String.fromCharCode(31) + 'Network unavailable');
            xhr.onabort = () => resolve('0' + String.fromCharCode(31) + 'Request aborted');
            xhr.send(body);
        }),
        'fw.general.rest.jsXhrGetRawAsync' : (url, authHeader, tenantDomain) => new Promise(function(resolve) {
                var xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);
                if (authHeader && authHeader.length > 0) {
                    xhr.setRequestHeader('Authorization', authHeader);
                }
                if (tenantDomain && tenantDomain.length > 0) {
                    xhr.setRequestHeader('X-MC-Tenant-Domain', tenantDomain);
                }
                xhr.onload  = function() { resolve(xhr.status + '\u001f' + (xhr.responseText || '')); };
                xhr.onerror = function() { resolve('0\u001f' + 'Network error'); };
                xhr.send(null);
            }),
        'fw.general.rest.jsXhrPostMultipartAsync' : (url, data, fileName, mimeType, fieldName, headersJson) => new Promise(function(resolve, reject) {
                var blob = new Blob([data], { type: mimeType });
                var fd = new FormData();
                fd.append(fieldName, blob, fileName);
                var xhr = new XMLHttpRequest();
                xhr.open('POST', url, true);
                if (headersJson && headersJson !== '{}') {
                    try {
                        var h = JSON.parse(headersJson);
                        for (var k in h) { if (h.hasOwnProperty(k)) xhr.setRequestHeader(k, h[k]); }
                    } catch(e) {}
                }
                xhr.onload = function() {
                    if (xhr.status >= 400) {
                        reject(new Error('HTTP ' + xhr.status + ': ' + xhr.responseText));
                    } else {
                        resolve(xhr.responseText);
                    }
                };
                xhr.onerror = function() { reject(new Error('Network error')); };
                xhr.send(fd);
            }),
        'fw.general.rest.jsXhrGetBlobUrlAsync' : (url, headersJson) => new Promise(function(resolve, reject) {
                var xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);
                xhr.responseType = 'blob';
                if (headersJson && headersJson !== '{}') {
                    try {
                        var h = JSON.parse(headersJson);
                        for (var k in h) { if (h.hasOwnProperty(k)) xhr.setRequestHeader(k, h[k]); }
                    } catch(e) {}
                }
                xhr.onload = function() {
                    if (xhr.status >= 400) {
                        reject(new Error('HTTP ' + xhr.status));
                    } else {
                        var blobUrl = (window.URL || window.webkitURL).createObjectURL(xhr.response);
                        resolve(blobUrl);
                    }
                };
                xhr.onerror = function() { reject(new Error('Network error')); };
                xhr.send(null);
            }),
        'fw.general.rest.jsTenantDomain' : () => {
                if (typeof window === 'undefined') return '';
                if (typeof window.__MC_TENANT_DOMAIN === 'string' && window.__MC_TENANT_DOMAIN.length > 0) {
                    return window.__MC_TENANT_DOMAIN;
                }
                var host = (window.location && window.location.hostname) ? window.location.hostname : '';
                if (host === 'localhost' || host === '127.0.0.1' || host === '::1' || host === '0.0.0.0') return '';
                return host;
            },
        'fw.general.rest.jsCreateUint8ArrayBuilder' : (len) => ({ arr: new Uint8Array(len), set: function(i, v) { this.arr[i] = v; }, get: function() { return this.arr; } }),
        'fw.general.rest.jsSetByte' : (builder, i, v) => builder.set(i, v),
        'fw.general.rest.jsGetUint8Array' : (builder) => builder.get(),
        'fw.general.sheet.jsClipboardWriteText' : (text) => navigator.clipboard.writeText(text),
        'fw.general.sheet.jsClipboardReadText' : () => navigator.clipboard.readText(),
        'fw.general.sheet.jsObserveSheetPaste' : (isActive, callback) => {
                const sink = document.createElement('textarea');
                sink.setAttribute('aria-hidden', 'true');
                sink.setAttribute('autocomplete', 'off');
                sink.tabIndex = -1;
                Object.assign(sink.style, {
                    position: 'fixed',
                    left: '-10000px',
                    top: '0',
                    width: '1px',
                    height: '1px',
                    opacity: '0',
                    pointerEvents: 'none'
                });
                document.body.appendChild(sink);
        
                let previousFocus = null;
                const keyHandler = function(event) {
                    if (!isActive()) return;
                    const key = String(event.key || '').toLowerCase();
                    if (key !== 'v' || (!event.metaKey && !event.ctrlKey) || event.altKey) return;
                    const target = event.target;
                    const tag = target && target.tagName ? String(target.tagName).toLowerCase() : '';
                    if (tag === 'input' || tag === 'textarea' || (target && target.isContentEditable)) return;
                    previousFocus = document.activeElement;
                    sink.value = '';
                    sink.focus({ preventScroll: true });
                    sink.select();
                };
        
                const pasteHandler = function(event) {
                    if (!isActive()) return;
                    const target = event.target;
                    const tag = target && target.tagName ? String(target.tagName).toLowerCase() : '';
                    const isSink = target === sink;
                    if (!isSink && (tag === 'input' || tag === 'textarea' || (target && target.isContentEditable))) return;
                    const data = event.clipboardData;
                    if (!data) return;
                    const text = data.getData('text/plain');
                    if (typeof text !== 'string' || text.length === 0) return;
                    event.preventDefault();
                    callback(text);
        
                    const restore = previousFocus;
                    previousFocus = null;
                    queueMicrotask(function() {
                        if (restore && typeof restore.focus === 'function') {
                            try {
                                restore.focus({ preventScroll: true });
                                return;
                            } catch (_) {}
                        }
                        sink.blur();
                    });
                };
        
                document.addEventListener('keydown', keyHandler, true);
                document.addEventListener('paste', pasteHandler, true);
                return { keyHandler, pasteHandler, sink };
            },
        'fw.general.sheet.__convertKotlinClosureToJsClosure_(()->Boolean)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Boolean)'](f, )),
        'fw.general.sheet.jsRemoveSheetPasteObserver' : (observer) => {
                if (!observer) return;
                document.removeEventListener('keydown', observer.keyHandler, true);
                document.removeEventListener('paste', observer.pasteHandler, true);
                if (observer.sink && observer.sink.parentNode) observer.sink.parentNode.removeChild(observer.sink);
            },
        'fw.general.sheet.jsSupportsClipboardRead' : () => globalThis.isSecureContext === true && !!(navigator.clipboard && navigator.clipboard.readText),
        'fw.general.sheet.jsIsMac' : () => /Mac/.test(navigator.platform),
        'gen.triggers.platform.jsGetBattery' : () => {
            if (!navigator.getBattery) return null;
            return navigator.getBattery();
        },
        'gen.triggers.platform.jsGetMemoryInfo' : () => {
            if (performance && performance.memory) {
                return [
                    Math.round((performance.memory.totalJSHeapSize - performance.memory.usedJSHeapSize) / 1048576),
                    Math.round(performance.memory.totalJSHeapSize / 1048576)
                ];
            }
            return null;
        },
        'gen.triggers.platform.jsMemAvailable' : (arr) => arr[0],
        'gen.triggers.platform.jsMemTotal' : (arr) => arr[1],
        'gen.triggers.platform.jsIsDocumentVisible' : () => !document.hidden,
        'gen.triggers.platform.jsNavigatorOnLine' : () => navigator.onLine,
        'gen.triggers.platform.jsNetworkType' : () => {
            if (navigator.connection && navigator.connection.type) {
                var t = navigator.connection.type;
                if (t === 'wifi')      return 'WIFI';
                if (t === 'cellular')  return 'CELLULAR';
                if (t === 'ethernet')  return 'ETHERNET';
                return 'OTHER';
            }
            return navigator.onLine ? 'OTHER' : 'NONE';
        },
        'com.example.kmpeditor.theme.jsGetItem' : (key) => localStorage.getItem(key),
        'com.example.kmpeditor.theme.jsSetItem' : (key, value) => localStorage.setItem(key, value),
        'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
        'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
        'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
        'org.jetbrains.compose.resources.jsExportInt8ArrayToWasm' :  (src, size, dstAddr) => {
                const mem8 = new Int8Array(wasmExports.memory.buffer, dstAddr, size);
                mem8.set(src);
            }
        ,
        'org.jetbrains.compose.resources.requestResponseAsByteArray' : (req) =>  {
                var text = req.responseText;
                var int8Arr = new Int8Array(text.length);
                for (var i = 0; i < text.length; i++) {
                    int8Arr[i] = text.charCodeAt(i) & 0xFF;
                }
                return int8Arr;
            },
        'org.jetbrains.compose.resources.isInTestEnvironment' : () => window.composeResourcesTesting == true,
        'com.example.mcwebdeditor.app.chatbot.jsTenantDomain' : () => {
                if (typeof window === 'undefined') return '';
                if (typeof window.__MC_TENANT_DOMAIN === 'string' && window.__MC_TENANT_DOMAIN.length > 0) {
                    return window.__MC_TENANT_DOMAIN;
                }
                var host = (window.location && window.location.hostname) ? window.location.hostname : '';
                if (host === 'localhost' || host === '127.0.0.1' || host === '::1' || host === '0.0.0.0') return '';
                return host;
            },
        'com.example.mcwebdeditor.app.chatbot.jsStartChatbotReply' : (url, body, authHeader, tenantDomain, onEvent, onDone, onError) => {
                var controller = new AbortController();
                var closed = false;
                function finish() {
                    if (closed) return;
                    closed = true;
                    onDone();
                }
                function fail(err) {
                    if (closed) return;
                    closed = true;
                    if (err && err.name === 'AbortError') {
                        onDone();
                        return;
                    }
                    var message = err && err.message ? err.message : String(err || 'Unknown stream error');
                    onError(message);
                }
                (async function() {
                try {
                    var headers = {
                        'Content-Type': 'application/json',
                        'Accept': 'text/event-stream'
                    };
                    if (authHeader && authHeader.length > 0) headers['Authorization'] = authHeader;
                    if (tenantDomain && tenantDomain.length > 0) headers['X-MC-Tenant-Domain'] = tenantDomain;
        
                    var response = await fetch(url, {
                        method: 'POST',
                        headers: headers,
                        body: body,
                        signal: controller.signal
                    });
                    if (!response.ok) {
                        var errorText = await response.text().catch(function() { return ''; });
                        fail(new Error('HTTP ' + response.status + ': ' + errorText));
                        return;
                    }
                    if (!response.body || !response.body.getReader) {
                        fail(new Error('Streaming responses are not supported by this browser'));
                        return;
                    }
        
                    var reader = response.body.getReader();
                    var decoder = new TextDecoder();
                    var buffer = '';
        
                    while (true) {
                        var read = await reader.read();
                        if (read.done) break;
                        buffer += decoder.decode(read.value, {stream: true});
                        var idx;
                        while ((idx = buffer.indexOf('\n\n')) >= 0) {
                            var frame = buffer.slice(0, idx);
                            buffer = buffer.slice(idx + 2);
                            var lines = frame.split(/\r?\n/);
                            var dataLines = [];
                            for (var i = 0; i < lines.length; i++) {
                                if (lines[i].indexOf('data:') === 0) dataLines.push(lines[i].slice(5).trimStart());
                            }
                            if (!dataLines.length) continue;
                            var data = dataLines.join('\n');
                            if (data === '[DONE]') {
                                finish();
                                return;
                            }
                            onEvent(data);
                        }
                    }
                    finish();
                } catch (err) {
                    fail(err);
                }
                })();
                return {
                    abort: function() {
                        if (closed) return;
                        closed = true;
                        controller.abort();
                    }
                };
            },
        'com.example.mcwebdeditor.app.chatbot.jsAbortChatbotReply' : (handle) => { if (handle && typeof handle.abort === 'function') handle.abort(); },
        'com.example.mcwebdeditor.app.hifishow.jsFormatAccessDate' : (value) => {
            const date = new Date(value);
            if (!Number.isFinite(date.getTime())) return value;
            const formatter = new Intl.DateTimeFormat('sv-SE', {timeZone:'Europe/Budapest',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hour12:false});
            return formatter.format(date) + ' (Budapest)';
        },
        'com.example.mcwebdeditor.app.hifishow.jsConsumeSetupInvite' : () => {
            const params = new URLSearchParams(window.location.hash.slice(1));
            if (!params.has('setupInvite')) return '';
            const invite = params.get('setupInvite') || 'invalid';
            params.delete('setupInvite');
            const hash = params.toString();
            history.replaceState(history.state, '', window.location.pathname + window.location.search + (hash ? '#' + hash : ''));
            return invite;
        },
        'com.example.mcwebdeditor.app.hifishow.jsCopyAccessText' : async (text) => {
            try {
                if (globalThis.isSecureContext && navigator.clipboard) {
                    await navigator.clipboard.writeText(text);
                    return true;
                }
            } catch (_) {}
            const element = document.createElement('textarea');
            element.value = text;
            element.style.cssText = 'position:fixed;left:-9999px;top:0';
            document.body.appendChild(element);
            element.focus(); element.select();
            try { return Boolean(document.execCommand('copy')); }
            catch (_) { return false; }
            finally { element.remove(); }
        },
        'com.example.mcwebdeditor.app.hifishow.jsDownloadAccessCsv' : (text) => {
            try {
                const url = URL.createObjectURL(new Blob(['\ufeff', text], {type: 'text/csv;charset=utf-8'}));
                const a = document.createElement('a');
                a.href = url; a.download = 'hifishow-exhibitor-links.csv';
                document.body.appendChild(a); a.click(); a.remove();
                setTimeout(() => URL.revokeObjectURL(url), 10000);
                return true;
            } catch (_) { return false; }
        },
        'com.example.mcwebdeditor.app.hifishow.trustedMediaPath' : (url, backendUrl) => {
            try {
                const backend = new URL(backendUrl, window.location.href);
                const target = new URL(url, window.location.href);
                if (!['https:', 'http:'].includes(backend.protocol) || target.protocol !== backend.protocol || target.origin !== backend.origin ||
                    target.username || target.password || backend.username || backend.password) return '';
                return target.pathname + '\n' + backend.pathname;
            } catch (_) { return ''; }
        },
        'com.example.mcwebdeditor.app.messaging.jsOpenHtmlInNewTab' : (html, title) => {
                const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
                const url = URL.createObjectURL(blob);
                const w = window.open(url, '_blank');
                if (w) { try { w.document.title = title; } catch (e) {} }
                setTimeout(() => URL.revokeObjectURL(url), 60000);
            },
        'com.example.mcwebdeditor.app.shopify.jsCopyShopifyTextToClipboard' : (text) => {
                try {
                    if (typeof document !== 'undefined' && document.body) {
                        const textarea = document.createElement('textarea');
                        textarea.value = String(text || '');
                        textarea.setAttribute('readonly', 'readonly');
                        textarea.setAttribute('aria-hidden', 'true');
                        Object.assign(textarea.style, {
                            position: 'fixed',
                            left: '-10000px',
                            top: '0',
                            width: '1px',
                            height: '1px',
                            opacity: '0',
                            pointerEvents: 'none'
                        });
                        document.body.appendChild(textarea);
                        textarea.focus({ preventScroll: true });
                        textarea.select();
                        textarea.setSelectionRange(0, textarea.value.length);
                        const copied = document.execCommand && document.execCommand('copy');
                        document.body.removeChild(textarea);
                        if (copied) return true;
                    }
                } catch (_) {}
                try {
                    if (globalThis.isSecureContext === true && navigator.clipboard && navigator.clipboard.writeText) {
                        navigator.clipboard.writeText(String(text || '')).catch(function() {});
                        return true;
                    }
                } catch (_) {}
                return false;
            },
        'com.example.mcwebdeditor.i18n.jsNavigatorLanguage' : () => (typeof window !== 'undefined' && window.navigator && typeof window.navigator.language === 'string') ? window.navigator.language : '',
        'com.example.mcwebdeditor.i18n.jsQueryParam' : (name) => {
            try {
                var p = new URLSearchParams(window.location.search || '');
                var v = p.get(name);
                return typeof v === 'string' ? v.trim() : '';
            } catch (_e) {
                return '';
            }
        },
        'com.example.mcwebdeditor.i18n.jsRegisterPopstate' : (callbackId) => {
            if (typeof window === 'undefined') return;
            var handler = function () {
                var cb = window.__seoWizardLangListeners && window.__seoWizardLangListeners[callbackId];
                if (typeof cb === 'function') cb();
            };
            if (!window.__seoWizardLangHandlers) window.__seoWizardLangHandlers = {};
            window.__seoWizardLangHandlers[callbackId] = handler;
            window.addEventListener('popstate', handler);
        },
        'com.example.mcwebdeditor.i18n.jsUnregisterPopstate' : (callbackId) => {
            if (typeof window === 'undefined') return;
            var handler = window.__seoWizardLangHandlers && window.__seoWizardLangHandlers[callbackId];
            if (handler) {
                window.removeEventListener('popstate', handler);
                delete window.__seoWizardLangHandlers[callbackId];
            }
            if (window.__seoWizardLangListeners) {
                delete window.__seoWizardLangListeners[callbackId];
            }
        },
        'com.example.mcwebdeditor.i18n.jsStoreCallback' : (callbackId, cb) => {
            if (typeof window === 'undefined') return;
            if (!window.__seoWizardLangListeners) window.__seoWizardLangListeners = {};
            window.__seoWizardLangListeners[callbackId] = cb;
        },
        'com.example.mcwebdeditor.platform.jsLocationHostname' : () => window.location.hostname || '',
        'com.example.mcwebdeditor.platform.jsLocationOrigin' : () => window.location.origin,
        'com.example.mcwebdeditor.platform.jsMcwebdRuntimeMode' : () => { var env = window.__MCWEBD_ENV || {}; return typeof env.MCWEBD_RUNTIME_MODE === 'string' ? env.MCWEBD_RUNTIME_MODE : ''; },
        'com.example.mcwebdeditor.platform.jsDevLoginEmail' : () => { var env = window.__MCWEBD_ENV || {}; return typeof env.MCWEBD_DEV_LOGIN_EMAIL === 'string' ? env.MCWEBD_DEV_LOGIN_EMAIL : ''; },
        'com.example.mcwebdeditor.platform.jsDevLoginPassword' : () => { var env = window.__MCWEBD_ENV || {}; return typeof env.MCWEBD_DEV_LOGIN_PASSWORD === 'string' ? env.MCWEBD_DEV_LOGIN_PASSWORD : ''; },
        'com.example.mcwebdeditor.platform.jsNavigateToTenantLogin' : () => {
            const params = new URLSearchParams(window.location.search || '');
            const host = window.location.hostname || '';
            function tenantHost(value) {
                const clean = String(value || '').trim().toLowerCase();
                if (clean.indexOf('admin.') === 0) return clean.slice(6);
                if (clean.indexOf('design.') === 0) return clean.slice(7);
                return clean;
            }
            function isLocalHost(value) {
                return value === 'localhost' || value === '127.0.0.1' || value === '::1' || value === '0.0.0.0';
            }
            function isLocalTenantHost(value) {
                const clean = tenantHost(value);
                return isLocalHost(clean)
                    || clean.indexOf('local.') === 0
                    || clean.endsWith('.localhost')
                    || clean.endsWith('.local');
            }
            const targetUrl = new URL('/', window.location.origin);
            if (isLocalTenantHost(host)) {
                const tenantDomain = params.get('tenantDomain')
                    || params.get('MC_TENANT_DOMAIN')
                    || params.get('tenant_domain')
                    || (typeof window.__MC_TENANT_DOMAIN === 'string' ? window.__MC_TENANT_DOMAIN : '')
                    || '';
                const centerRendererUrl = params.get('centerRendererUrl')
                    || (typeof window.__CENTER_RENDERER_URL === 'string' ? window.__CENTER_RENDERER_URL : '')
                    || '';
                if (tenantDomain) targetUrl.searchParams.set('tenantDomain', tenantDomain);
                if (centerRendererUrl) targetUrl.searchParams.set('centerRendererUrl', centerRendererUrl);
            }
            const target = targetUrl.toString();
            if (window.location.href === target) {
                window.location.reload();
            } else {
                window.location.replace(target);
            }
        },
        'com.example.mcwebdeditor.platform.jsStoreEscapeCallback' : (id, callback) => {
                if (typeof window === 'undefined') return;
                if (!window.__mcwebdEscapeNavigationCallbacks) window.__mcwebdEscapeNavigationCallbacks = {};
                window.__mcwebdEscapeNavigationCallbacks[id] = callback;
            },
        'com.example.mcwebdeditor.platform.jsInstallEscapeListener' : (id) => {
                if (typeof document === 'undefined' || typeof window === 'undefined') return;
                if (!window.__mcwebdEscapeNavigationHandlers) window.__mcwebdEscapeNavigationHandlers = {};
                var stop = function(event) {
                    if (typeof event.preventDefault === 'function') event.preventDefault();
                    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
                    else if (typeof event.stopPropagation === 'function') event.stopPropagation();
                };
                var handledReturn = function(raw) {
                    if (raw === true || raw === 'true') return true;
                    if (raw && typeof raw.valueOf === 'function') return raw.valueOf() === true;
                    return false;
                };
                var handler = function(event) {
                    if (!event || (event.key !== 'Escape' && event.key !== 'Esc' && event.code !== 'Escape')) return;
                    if (event.type === 'keyup' && window.__mcwebdEscapeNavigationSuppressKeyup) {
                        window.__mcwebdEscapeNavigationSuppressKeyup = false;
                        stop(event);
                        return;
                    }
                    var callbacks = window.__mcwebdEscapeNavigationCallbacks || {};
                    var callback = callbacks[id];
                    if (typeof callback !== 'function') return;
                    var handled = handledReturn(callback());
                    if (!handled) return;
                    if (event.type === 'keydown') window.__mcwebdEscapeNavigationSuppressKeyup = true;
                    stop(event);
                };
                window.__mcwebdEscapeNavigationHandlers[id] = handler;
                document.addEventListener('keydown', handler, true);
                document.addEventListener('keyup', handler, true);
            },
        'com.example.mcwebdeditor.platform.jsUninstallEscapeListener' : (id) => {
                if (typeof document === 'undefined' || typeof window === 'undefined') return;
                var handlers = window.__mcwebdEscapeNavigationHandlers || {};
                var handler = handlers[id];
                if (handler) {
                    document.removeEventListener('keydown', handler, true);
                    document.removeEventListener('keyup', handler, true);
                    delete handlers[id];
                }
                if (window.__mcwebdEscapeNavigationCallbacks) {
                    delete window.__mcwebdEscapeNavigationCallbacks[id];
                }
            },
        'com.example.mcwebdeditor.routing.jsPathname' : () => window.location.pathname || '/',
        'com.example.mcwebdeditor.routing.jsSurfaceBasePath' : () => {
            const configured = typeof window.__MCWEBD_SURFACE_BASE_PATH === 'string'
                ? window.__MCWEBD_SURFACE_BASE_PATH.trim()
                : '';
            if (configured) return configured.replace(/\/+$/, '');
            return /^\/admin(?:\/|$)/.test(window.location.pathname || '') ? '/admin' : '';
        },
        'com.example.mcwebdeditor.routing.jsWritePath' : (path, replace, surfaceBasePath) => {
                function tenantHost(value) {
                    const host = String(value || '').trim().toLowerCase();
                    if (host.indexOf('admin.') === 0) return host.slice(6);
                    if (host.indexOf('design.') === 0) return host.slice(7);
                    return host;
                }
                function isLocalHost(value) {
                    return value === 'localhost' || value === '127.0.0.1' || value === '::1' || value === '0.0.0.0';
                }
                function isLocalTenantHost(value) {
                    const host = tenantHost(value);
                    return isLocalHost(host)
                        || host.indexOf('local.') === 0
                        || host.endsWith('.localhost')
                        || host.endsWith('.local');
                }
                function cleanedSearch() {
                    const params = new URLSearchParams(window.location.search || '');
                    params.delete('centerBackendUrl');
                    if (!isLocalTenantHost(window.location.hostname || '')) {
                        ['centerRendererUrl', 'tenantDomain', 'MC_TENANT_DOMAIN', 'tenant_domain']
                            .forEach((name) => params.delete(name));
                    }
                    const text = params.toString();
                    return text ? '?' + text : '';
                }
                const base = String(surfaceBasePath || '').trim().replace(/\/+$/, '');
                const routePath = path || '/';
                const prefixedPath = base === '/admin' && routePath === '/admin/setup'
                    ? routePath
                    : base
                    ? (routePath === '/' ? base + '/' : base + (routePath.charAt(0) === '/' ? routePath : '/' + routePath))
                    : routePath;
                const target = prefixedPath + cleanedSearch() + window.location.hash;
                const current = window.location.pathname + window.location.search + window.location.hash;
                if (target === current) return false;
                if (replace) history.replaceState(null, '', target);
                else history.pushState(null, '', target);
                return true;
            },
        'com.example.mcwebdeditor.routing.jsInstallPopstateListener' : (callback) => {
                window.addEventListener('popstate', function() {
                    callback();
                });
            },
        'core.general.menu.jsGetItem' : (key) => localStorage.getItem(key),
        'core.general.menu.jsSetItem' : (key, value) => localStorage.setItem(key, value),
        'core.general.menu.jsRemoveItem' : (key) => localStorage.removeItem(key),
        'core.general.menu.jsSessionSet' : (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} },
        'core.general.menu.jsSessionGet' : (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
        'gen.dashboard.jsNowIso' : () => new Date().toISOString(),
        'gen.partnershipregistration.jsOpenPrivateRegistrationLogo' : (url, token) => {
                const tab = window.open('', '_blank');
                if (!tab) return;
                tab.opener = null;
                tab.document.title = 'Uploaded logo';
                tab.document.body.textContent = 'Loading logo...';
                const configuredTenant = window.__MC_TENANT_DOMAIN;
                const tenantDomain = (typeof configuredTenant === 'string' && configuredTenant)
                    ? configuredTenant : window.location.hostname.replace(/^admin\./, '');
                const headers = { Authorization: 'Bearer ' + token };
                if (tenantDomain && tenantDomain !== 'localhost' && tenantDomain !== '127.0.0.1') {
                    headers['X-MC-Tenant-Domain'] = tenantDomain;
                }
                fetch(url, { headers, cache: 'no-store' })
                    .then(response => {
                        if (!response.ok) throw new Error('HTTP ' + response.status);
                        return response.blob();
                    })
                    .then(blob => { tab.location.href = URL.createObjectURL(blob); })
                    .catch(() => { tab.document.body.textContent = 'Unable to open the logo.'; });
            }
    }
    
    // Placed here to give access to it from externals (js_code)
    let wasmInstance;
    let require; 
    let wasmExports;

    const isNodeJs = (typeof process !== 'undefined') && (process.release.name === 'node');
    const isDeno = !isNodeJs && (typeof Deno !== 'undefined')
    const isStandaloneJsVM =
        !isDeno && !isNodeJs && (
            typeof d8 !== 'undefined' // V8
            || typeof inIon !== 'undefined' // SpiderMonkey
            || typeof jscOptions !== 'undefined' // JavaScriptCore
        );
    const isBrowser = !isNodeJs && !isDeno && !isStandaloneJsVM && (typeof window !== 'undefined' || typeof self !== 'undefined');
    
    if (!isNodeJs && !isDeno && !isStandaloneJsVM && !isBrowser) {
      throw "Supported JS engine not detected";
    }
    
    const wasmFilePath = './mcwebd_editor.wasm';
    const importObject = {
        js_code,
        intrinsics: {
            
        },
        './skiko.mjs': imports['./skiko.mjs'],

    };
    
    try {
      if (isNodeJs) {
        const module = await import(/* webpackIgnore: true */'node:module');
        const importMeta = import.meta;
        require = module.default.createRequire(importMeta.url);
        const fs = require('fs');
        const url = require('url');
        const filepath = import.meta.resolve(wasmFilePath);
        const wasmBuffer = fs.readFileSync(url.fileURLToPath(filepath));
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject);
      }
      
      if (isDeno) {
        const path = await import(/* webpackIgnore: true */'https://deno.land/std/path/mod.ts');
        const binary = Deno.readFileSync(path.fromFileUrl(import.meta.resolve(wasmFilePath)));
        const module = await WebAssembly.compile(binary);
        wasmInstance = await WebAssembly.instantiate(module, importObject);
      }
      
      if (isStandaloneJsVM) {
        const wasmBuffer = read(wasmFilePath, 'binary');
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject);
      }
      
      if (isBrowser) {
        wasmInstance = (await WebAssembly.instantiateStreaming(fetch(new URL('./mcwebd_editor.wasm',import.meta.url).href), importObject)).instance;
      }
    } catch (e) {
      if (e instanceof WebAssembly.CompileError) {
        let text = `Please make sure that your runtime environment supports the latest version of Wasm GC and Exception-Handling proposals.
For more information, see https://kotl.in/wasm-help
`;
        if (isBrowser) {
          console.error(text);
        } else {
          const t = "\n" + text;
          if (typeof console !== "undefined" && console.log !== void 0) 
            console.log(t);
          else 
            print(t);
        }
      }
      throw e;
    }
    
    wasmExports = wasmInstance.exports;
    if (runInitializer) {
        wasmExports._initialize();
    }

    return { instance: wasmInstance,  exports: wasmExports };
}
